import { RouterProvider } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './context/AuthContext';
import { router } from './routes';
import ExitIntentPopup from './components/common/ExitIntentPopup';

function App() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
      {/* <ExitIntentPopup
        redirectUrl="https://tally.so/r/zxYKgR" // Replace with your actual URL
        delayBeforeShow={3000} // 3 seconds delay before popup can be triggered
        autoDismissDelay={15000} // 15 seconds before auto-dismiss
        showOnce={true} // Show only once per session
      /> */}
    </AuthProvider>
  );
}

export default App;
